export const StartUpFunc = [];